<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="名称"
        prop="title"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.title"
          placeholder="名称"
          clearable
          @change="(value)=>{form.title = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="链接"
        prop="url"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.url"
          placeholder="请输入链接地址"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="图片"
        style="margin-right:15px"
        :required="true"
      >
        <ImgUpload
          :upload-config="{ lebal: '案例图片', prefix: 'img', form, suffix: '', modal: false }"
          :parent-data="{ isDetail: false }"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import ImgUpload from "@/components/ImgUpload";

export default {
  name: 'PartnerShipsAdd',
  components: {
    ImgUpload
  },
  data() {
    return {
      form: {
        img: '',
        title: '',
        url: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在 1 到 255个字符', trigger: 'blur' }
        ],
        url: [
          // { validator: isURL, trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 255 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form
          request({ url: '/ntocc-basic-api/partnerShips', method: 'post', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherAddMethod')
          }).then(() => this.$refs['form'].resetFields())
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    },
    init() {
      this.form = {
        title: '',
        url: '',
        address: ''
      }
      this.$refs['form'].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
